import { ChartTooltip, ChartTooltipContent } from "@/components/ui/chart";

export function CustomChartTooltip() {
  return (
    <ChartTooltip
      content={({ active, payload }) => {
        if (!active || !payload) return null;
        return (
          <ChartTooltipContent
            className="border border-border/50 bg-background shadow-xl"
            payload={payload}
          />
        );
      }}
    />
  );
}